import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'src/utils/AxiosConfig';

// ** Fetch Users
export const getUsers = createAsyncThunk('appUsers/getUsers', async (params) => {
  const response = await axios.get('/api/users', { params })
  return response.data
})

// ** Fetch single User
export const getSingleUsers = createAsyncThunk('appUsers/getSingleUsers', async (id) => {
  const response = await axios.get(`/api/users/${id}`)
  return response.data
})

// ** Add User
export const addUser = createAsyncThunk(
  'appUsers/addUser', 
  async (data, { getState, dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post('/api/users', { ...data })
      return response.data
    } catch (error) {
      // Reject with the error message or any other error details you want
      return rejectWithValue(error.response ? error.response.data : error.message)
    }
  }
)

export const updateUser = createAsyncThunk(
  'appUsers/updateUser', 
  async ({ id, ...data}, { getState, dispatch, rejectWithValue }) => {
    try {
      const response = await axios.put(`/api/users/${id}`, { ...data })
      return response.data
    } catch (error) {
      // Reject with the error message or any other error details you want
      return rejectWithValue(error.response ? error.response.data : error.message)
    }
  }
)

// ** Delete User
export const deleteUser = createAsyncThunk('appUsers/deleteUser', async (id, { getState, dispatch }) => {
  const response = await axios.delete(`/api/users/${id}`)
  dispatch(getUsers(getState().user.params)) // Refresh user list after deletion
  return response.data
})

export const appUsersSlice = createSlice({
  name: 'appUsers',
  initialState: {
    singleData: {},   // Data for a single user
    data: [],         // Data for a list of users
    total: 0,
    params: {},
    allData: [],      // (Optional) Store all user data if needed
    status: 'idle',
    message:null,
    errors: null
  },
  reducers: {
    resetSingleUser: (state) => {
      state.singleData = {}; // Reset single user data
    },
    resetStateIdele: (state) => {
      state.status = 'idle'; // Reset single user data
    }
  },
  extraReducers: (builder) => {
    // ** Fetch Multiple Users
    builder
      .addCase(getUsers.pending, (state) => {
        state.status = 'loading'
        state.message = null;
        state.errors = null
      })
      .addCase(getUsers.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.data = action.payload.data
        state.total = action.payload.total
        state.params = action.payload.params
      })
      .addCase(getUsers.rejected, (state, action) => {
        state.status = 'failed'
        state.message = null
        state.errors = null
      })

    // ** Add User
    builder
      .addCase(addUser.pending, (state) => {
        state.status = 'loading'
        state.message = null;
        state.errors = null
      })
      .addCase(addUser.fulfilled, (state) => {
        state.status = 'succeeded'
      })
      .addCase(addUser.rejected, (state, action) => {
        state.status = 'failed'
        state.message = action.payload?.message
        state.errors = action.payload?.errors
      })

    builder
      .addCase(updateUser.pending, (state) => {
        state.status = 'loading'
        state.message = null;
        state.errors = null
      })
      .addCase(updateUser.fulfilled, (state) => {
        state.status = 'succeeded'
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.status = 'failed'
        state.message = action.payload.message
        state.errors = action.payload.errors
      })

    // ** Delete User
    builder
      .addCase(deleteUser.pending, (state) => {
        state.status = 'loading'
        state.message = null;
        state.errors = null
      })
      .addCase(deleteUser.fulfilled, (state) => {
        state.status = 'succeeded'
      })
      .addCase(deleteUser.rejected, (state, action) => {
        state.status = 'failed'
        state.message = action.error.message || 'Something went wrong';
        state.errors = action.error.details || ['An unknown error occurred'];
      })

    // ** Fetch Single User
    builder
      .addCase(getSingleUsers.pending, (state) => {
        state.status = 'loading'
        state.message = null;
        state.errors = null
      })
      .addCase(getSingleUsers.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.singleData = action.payload.data
      })
      .addCase(getSingleUsers.rejected, (state, action) => {
        state.status = 'failed'
        state.message = action.payload?.message
        state.errors = action.payload?.errors
      })
  }
})

export const { resetSingleUser, resetStateIdele } = appUsersSlice.actions;

export default appUsersSlice.reducer
